import React from 'react';
import ReactDOM from 'react-dom';
import { motion } from 'framer-motion';
import useModuleConfigTheme from '../../../shared/hooks/useModuleConfigTheme';

/** Themed create/edit portal shell — matches ApprobationsCrudShell / QawaemErpCrudModal. */
export function InventaireModalPortal({
  show,
  onClose,
  children,
  maxWidth = '1200px',
  testId,
}) {
  const cfgTheme = useModuleConfigTheme();
  const isLight = cfgTheme.light;

  if (!show) return null;

  return ReactDOM.createPortal(
    <div
      className="fixed inset-0 bg-black/20 backdrop-blur-md flex items-center justify-center z-[99999] p-4"
      onClick={onClose}
      role="presentation"
    >
      <motion.div
        data-testid={testId}
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.95 }}
        className={`backdrop-blur-lg rounded-2xl max-h-[90vh] flex flex-col overflow-hidden ${
          isLight
            ? 'qawaem-modal-light border'
            : 'border-2 border-blue-400/60 bg-gradient-to-br from-slate-800 via-blue-750 to-slate-800'
        }`}
        style={
          isLight
            ? { boxShadow: '0 10px 40px rgba(15, 23, 42, 0.12), 0 0 0 1px rgba(15, 23, 42, 0.06)', width: '90%', maxWidth }
            : { boxShadow: '0 0 40px rgba(59, 130, 246, 0.4), 0 0 80px rgba(59, 130, 246, 0.2)', width: '90%', maxWidth }
        }
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </motion.div>
    </div>,
    document.body,
  );
}

/** Themed read-only view portal shell. */
export function InventaireViewModalPortal({
  show,
  record,
  onClose,
  children,
  maxWidth = '720px',
  testId,
}) {
  const cfgTheme = useModuleConfigTheme();
  const isLight = cfgTheme.light;

  if (!show || !record) return null;

  return ReactDOM.createPortal(
    <div
      className="fixed inset-0 bg-black/20 backdrop-blur-md flex items-center justify-center z-[99999] p-4"
      onClick={onClose}
      role="presentation"
    >
      <motion.div
        data-testid={testId}
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className={`backdrop-blur-lg rounded-2xl max-h-[90vh] flex flex-col overflow-hidden ${
          isLight
            ? 'qawaem-modal-light border'
            : 'border-2 border-blue-400/60 bg-gradient-to-br from-slate-800 via-blue-750 to-slate-800'
        }`}
        style={
          isLight
            ? { boxShadow: '0 10px 40px rgba(15, 23, 42, 0.12), 0 0 0 1px rgba(15, 23, 42, 0.06)', width: '90%', maxWidth }
            : { boxShadow: '0 0 40px rgba(59, 130, 246, 0.4), 0 0 80px rgba(59, 130, 246, 0.2)', width: '90%', maxWidth }
        }
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </motion.div>
    </div>,
    document.body,
  );
}

export { useModuleConfigTheme as useInventaireModalTheme };
